import React, { useEffect } from 'react';
import { history, Redirect, connect } from 'umi';

import { Skeleton } from 'antd';
import { isEmpty } from 'lodash';
import Expired from '@/components/Expired';
import PostPaidC2C from '@/pages/PostPaidC2C';

const LuckyDrawHome = props => {
  const { qryLuckyDrawDetailDXP, gameCode, activityDetail = {}, Luckycode } = props;

  // 重定向 redirectUrl
  const { redirectUrl } = history.location.query;
  const { search } = history.location || {};

  const qryLuckyDraw = async () => {
    if (redirectUrl === 'prizeCenter') {
      return;
    }
    const { promotionId } = history.location.query;
    localStorage.setItem('promotionId', JSON.stringify({ promotionId }));
    const res = await qryLuckyDrawDetailDXP({ gameCode });
    const luckyDrawType = res?.data?.luckyDrawType;
    if (luckyDrawType !== 'R' && luckyDrawType !== 'N') {
      await qryLuckyDrawDetailDXP({ gameCode, luckyDrawType });
    }
  };

  useEffect(() => {
    qryLuckyDraw();
  }, []);

  useEffect(() => {
    if (!isEmpty(activityDetail)) {
      const { promotionMediaItemDtoList } = activityDetail;
      const { serverUrl } = (promotionMediaItemDtoList || []).find(it => it.serverUrl) || {};
      if (!isEmpty(serverUrl)) {
        localStorage.setItem('serverUrl', serverUrl);
      }
    }
  }, [activityDetail]);

  const renderPage = () => {
    let Page = null;
    if (activityDetail.luckyDrawType === 'J') {
      Page = PostPaidC2C;
    }
    if (!Page) {
      return '';
    }
    return <Page />;
  };

  if (!isEmpty(redirectUrl)) {
    return <Redirect to={`/${redirectUrl}${search}`} />;
  }

  // if (Luckycode === '2') {
  //   return '';
  // }
  if (Luckycode === '0') {
    // de
    return renderPage();
  }
  if (Luckycode === '5' || Luckycode === '2') {
    return (
      <Skeleton
        active
        paragraph={{
          rows: 20,
        }}
      />
    );
  }

  return <Expired />;
};

const mapDispatchToProps = dispatch => ({
  // 查询活动详情
  qryLuckyDrawDetailDXP: payload =>
    dispatch({
      type: 'index/qryLuckyDrawDetailDXP',
      payload,
    }),
});

export default connect(
  ({ index }) => ({
    defaultPlayChances: index.defaultPlayChances,
    winningUserList: index.winningUserList,
    rewardsList: index.rewardsList,
    activityDetail: index.activityDetail,
    Luckycode: index.Luckycode,
    gameCode: index.gameCode,
  }),
  mapDispatchToProps,
)(LuckyDrawHome);
